import { Supplier } from 'entities/Property/model/types/PropertySchema';

export interface ProductSourcingSchema {
    listOfSuppliers: Supplier[] | null;
    isLoadingSuppliers: boolean;
    isSaveSettings: boolean;
    isSaveSettingsToAllProperties: boolean;
    listOfSourcingModes: string[] | null;
    isLoadingSourcingModes: boolean;
}

export enum ProductSourcingModes {
    AvailabilityPrice = 'AVAILABILITY_PRICE',
    OnlyPreferred = 'ONLY_PREFERRED',
    HighlightPreferred = 'HIGHLIGHT_PREFERRED',
}

export enum ProductPriceSortingModes {
    BestPrice = 'BEST_PRICE',
    Custom = 'CUSTOM',
}
